import { gql } from '@apollo/client';

/**
 * GraphQL Queries
 *
 * All queries for fetching data from the backend
 */

// Get all words with optional filtering
export const GET_WORDS = gql`
  query GetWords($hskLevel: Int, $difficulty: String, $topics: [String!], $limit: Int, $offset: Int) {
    words(hskLevel: $hskLevel, difficulty: $difficulty, topics: $topics, limit: $limit, offset: $offset) {
      id
      hanzi
      pinyin
      image
      audio
      difficulty
      hskLevel
      topics
      meanings {
        partOfSpeech
        definition
        examples {
          cn
          en
          pinyin
          audio
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// Get a single word by ID
export const GET_WORD = gql`
  query GetWord($id: ID!) {
    word(id: $id) {
      id
      hanzi
      pinyin
      image
      audio
      difficulty
      hskLevel
      topics
      meanings {
        partOfSpeech
        definition
        examples {
          cn
          en
          pinyin
          audio
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// Get word count
export const GET_WORD_COUNT = gql`
  query GetWordCount($hskLevel: Int, $difficulty: String, $topics: [String!]) {
    wordCount(hskLevel: $hskLevel, difficulty: $difficulty, topics: $topics)
  }
`;

// Get all available topics
export const GET_TOPICS = gql`
  query GetTopics {
    topics
  }
`;

// Health check
export const PING = gql`
  query Ping {
    ping
  }
`;
